import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import { uk } from 'vuetify/locale'
export default createVuetify({
    defaultSet: 'mdi',
    dark: false,
    aliases,
    theme: {
        defaultTheme: 'light',
    },
    locale: {
        locale: 'uk',
        messages: { uk },
        fallback: 'en'
    },
    defaults: {
        global: {
            style: {
                fontFamily: 'Inter, sans-serif'
            }
        }
    },
    sets: {
        mdi,
    },
    components,
    directives,
})
